import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/midders/Code/xedi-microservices/sdk-js/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import { Flash } from '@primer/components';
import { Caption } from '@primer/gatsby-theme-doctocat';
import { InfoIcon } from '@primer/styled-octicons';
import { ExternalLink } from '../../src/components';
import { Link } from 'gatsby';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <p>{`Events are a mechanism supporting decoupled communication between components. They are part of the underlying `}<Link to="/development/api" mdxType="Link">{`API abstract class`}</Link>{` meaning they are available to all child classes. The usage for Events is simple and familiar.`}</p>
    <p>{`On a given service, you can subscribe to a topic using the `}<inlineCode parentName="p">{`on()`}</inlineCode>{` method, or you can fire an event using `}<inlineCode parentName="p">{`trigger()`}</inlineCode>{`.`}</p>
    <p>{`The best example of this is the usage as part of the `}<Link to="/architecture/authentication" mdxType="Link">{`authentication flow`}</Link>{`.`}</p>
    <p>{`In a number of the methods within the Auth API, the `}<inlineCode parentName="p">{`trigger()`}</inlineCode>{` method is called.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`this.trigger('auth_updated', {
    method: 'switch_context',
    data: {
        user: body.data.user,
        business: body.data.business,
        refresh_token: body.data.tokens.refresh,
        access_token: body.data.tokens.access,
    }
});
`}</code></pre>
    <Caption mdxType="Caption">
    <ExternalLink href="https://github.com/xedi/sdk-js/blob/master/src/Services/Auth.ts#L144" mdxType="ExternalLink">
        Auth.switchContexts
    </ExternalLink>
    </Caption>
    <p>{`Subscribing to the `}<inlineCode parentName="p">{`auth_updated`}</inlineCode>{` topic is also as straightforward as this.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`Xedi.Auth.on('auth_updated', (event) => {
    console.log(\`Auth state updated by \${ event.model }\`);
    console.log(\`Current user: \${ event.data.user.first_name });
    if (event.data.hasOwnProperty('business')) {
        console.log(\`Current business: \${ event.data.business.name }\`);
    }
});
`}</code></pre>
    <Flash mdxType="Flash"><InfoIcon mr={2} mdxType="InfoIcon" />These are not DOMEvents, nor do they implement the JavaScript Event interface.</Flash>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      